import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);

  // Modal & Interactive states
  const [activeBannerIdx, setActiveBannerIdx] = useState(0);
  const [showAllProducts, setShowAllProducts] = useState(false);
  const [selectedProductForTrade, setSelectedProductForTrade] = useState(null);
  const [showExpertModal, setShowExpertModal] = useState(false);
  const [expertForm, setExpertForm] = useState({ name: '', mobile: '', commodity: 'Cotton HVI' });
  const [expertSuccess, setExpertSuccess] = useState(false);

  // 14 Comprehensive Product & Function Cards (Matching PolicyBazaar layout)
  const productCards = [
    {
      id: 'cotton',
      title: 'Term Life Insurance', // mapped to Cotton Domestic (HVI)
      displayTitle: 'Domestic Cotton (HVI)',
      badge: 'Live Spot Rates',
      badgeClass: 'pb-ribbon-green',
      icon: '☁️',
      subtext: 'Shankar-6, J-34, MCU-5 with lab parameters',
      sellerRoute: '/seller/domestic-hvi?product=cotton',
      buyerRoute: '/buyer/domestic-hvi?product=cotton'
    },
    {
      id: 'cotton-desc',
      displayTitle: 'Cotton Description',
      badge: 'Lowest Price Guarantee',
      badgeClass: 'pb-ribbon-green',
      icon: '📋',
      subtext: 'Standard grade basis, direct ginner lots',
      sellerRoute: '/seller/domestic-description?product=cotton-desc',
      buyerRoute: '/buyer/domestic-description?product=cotton-desc'
    },
    {
      id: 'cotton-import',
      displayTitle: 'Import Cotton (Recap)',
      badge: 'Global Origins',
      badgeClass: 'pb-ribbon-green',
      icon: '🚢',
      subtext: 'US Pima, West African, Brazilian, Giza',
      sellerRoute: '/seller/import-recap?product=cotton-import',
      buyerRoute: '/buyer/import-recap?product=cotton-import'
    },
    {
      id: 'yarn',
      displayTitle: 'Cotton Yarn',
      badge: 'Direct Mill Price',
      badgeClass: 'pb-ribbon-green',
      icon: '🧵',
      subtext: 'Combed, Carded, Compact, Open End 20s-80s',
      sellerRoute: '/seller/domestic-hvi?product=yarn',
      buyerRoute: '/yarn'
    },
    {
      id: 'viscose',
      displayTitle: 'Viscose & Blends',
      badge: 'Upto 5% Discount',
      badgeClass: 'pb-ribbon-green',
      icon: '🧶',
      subtext: 'Eco-friendly, spun viscose & blended yarns',
      sellerRoute: '/seller/domestic-hvi?product=viscose',
      buyerRoute: '/buyer/domestic-hvi?product=viscose'
    },
    {
      id: 'mmf',
      displayTitle: 'Man-Made Fibre (MMF)',
      badge: 'Spot & Forward',
      badgeClass: 'pb-ribbon-green',
      icon: '🏭',
      subtext: 'Polyester, Nylon, Acrylic staple fiber',
      sellerRoute: '/seller/domestic-hvi?product=mmf',
      buyerRoute: '/mmf'
    },
    {
      id: 'organic',
      displayTitle: 'Organic & BCI Cotton',
      badge: '100% Certified',
      badgeClass: 'pb-ribbon-blue',
      icon: '🌿',
      subtext: 'GOTS, OEKO-TEX, BCI verified provenance',
      sellerRoute: '/seller/domestic-hvi?product=organic',
      buyerRoute: '/buyer/domestic-hvi?product=organic'
    },
    {
      id: 'cotton-waste',
      displayTitle: 'Cotton Waste & Linters',
      badge: 'Upto 20% Cheaper',
      badgeClass: 'pb-ribbon-green',
      icon: '♻️',
      subtext: 'Comber Noil, Dropping, Flat Waste, Yellow Pick',
      sellerRoute: '/seller/domestic-hvi?product=cotton-waste',
      buyerRoute: '/buyer/domestic-hvi?product=cotton-waste'
    },
    {
      id: 'spare-parts',
      displayTitle: 'Machinery & Spares',
      badge: 'New & Used',
      badgeClass: 'pb-ribbon-purple',
      icon: '⚙️',
      subtext: 'Ginning, spinning, blowroom & winding parts',
      sellerRoute: '/seller/domestic-hvi?product=spare-parts',
      buyerRoute: '/buyer/domestic-hvi?product=spare-parts'
    },
    {
      id: 'units',
      displayTitle: 'Mill / Ginning Units',
      badge: 'Sell / Lease / Convert',
      badgeClass: 'pb-ribbon-orange',
      icon: '🏢',
      subtext: 'Turnkey mills, conversion leases & gin setups',
      sellerRoute: '/seller/domestic-hvi?product=units',
      buyerRoute: '/buyer/domestic-hvi?product=units'
    },
    {
      id: 'fabric',
      displayTitle: 'Fabric & Greige',
      badge: 'Direct Weaving Mills',
      badgeClass: 'pb-ribbon-pink',
      icon: '👕',
      subtext: 'Cotton grey fabric, woven, knitted & printed',
      sellerRoute: '/seller/domestic-hvi?product=fabric',
      buyerRoute: '/buyer/domestic-hvi?product=fabric'
    },
    {
      id: 'lab-test',
      displayTitle: 'HVI Lab Testing',
      badge: 'NABL Certified',
      badgeClass: 'pb-ribbon-blue',
      icon: '🔬',
      subtext: 'Third-party HVI inspection & test certificates',
      sellerRoute: '/seller/domestic-hvi?product=cotton',
      buyerRoute: '/buyer/domestic-hvi?product=cotton'
    },
    {
      id: 'logistics',
      displayTitle: 'Logistics & Godown',
      badge: 'Insured Transit',
      badgeClass: 'pb-ribbon-green',
      icon: '🚚',
      subtext: 'Pan-India delivery, WDRA accredited godowns',
      sellerRoute: '/seller/domestic-hvi?product=cotton',
      buyerRoute: '/buyer/domestic-hvi?product=cotton'
    },
    {
      id: 'buyer-inquiry',
      displayTitle: 'Buyer Inquiries',
      badge: 'Instant Matching',
      badgeClass: 'pb-ribbon-purple',
      icon: '📢',
      subtext: 'Post custom demands, get instant ginner quotes',
      sellerRoute: '/seller/domestic-hvi?product=cotton',
      buyerRoute: '/buyer/inquiry-cotton'
    }
  ];

  // Carousel banners
  const promoBanners = [
    {
      headline: 'Best time to trade Cotton & Yarn is now',
      ribbon: 'Additional trade benefit up to ₹500/Candy*',
      buttonText: 'View Market Rates ›',
      rate: '0%',
      rateSub: 'Brokerage'
    },
    {
      headline: 'Publish & Contract Forward Delivery Deals',
      ribbon: 'Guaranteed Mill Payment within 48 Hrs*',
      buttonText: 'Explore Forward Trades ›',
      rate: '100%',
      rateSub: 'Payment Safety'
    },
    {
      headline: 'Verified Ginners from Gujarat, Maharashtra & MP',
      ribbon: 'NABL Certified HVI Test Parameter Reports',
      buttonText: 'Explore Certified Lots ›',
      rate: '500+',
      rateSub: 'Active Ginners'
    }
  ];

  const handleCardClick = (product) => {
    setSelectedProductForTrade(product);
  };

  const handleSelectRoleAndProceed = (role) => {
    if (!selectedProductForTrade) return;
    const targetProduct = selectedProductForTrade.id;
    localStorage.setItem('intendedRole', role);
    localStorage.setItem('intendedProduct', targetProduct);

    if (user) {
      if (role === 'seller') {
        navigate(selectedProductForTrade.sellerRoute || `/seller/domestic-hvi?product=${targetProduct}`);
      } else {
        navigate(selectedProductForTrade.buyerRoute || `/buyer/domestic-hvi?product=${targetProduct}`);
      }
    } else {
      navigate('/login');
    }
    setSelectedProductForTrade(null);
  };

  const handleExpertSubmit = (e) => {
    e.preventDefault();
    setExpertSuccess(true);
    setTimeout(() => {
      setExpertSuccess(false);
      setShowExpertModal(false);
      setExpertForm({ name: '', mobile: '', commodity: 'Cotton HVI' });
    }, 2000);
  };

  return (
    <div className="pb-landing-wrapper">
      {/* ---------------- Top Navbar ---------------- */}
      <header className="pb-navbar">
        <div className="pb-nav-container">
          <Link to="/" className="pb-logo-container">
            <div className="pb-logo-main">
              Go<span className="accent">Easy</span>Trade<span className="pb-logo-reg">®</span>
            </div>
            <span className="pb-logo-tagline">HAR TRADE HOGI SECURED</span>
          </Link>

          <ul className="pb-nav-links">
            <li className="pb-nav-item">
              <span>Trade Products</span>
              <span className="pb-nav-arrow">▼</span>
              <div className="pb-dropdown-panel">
                <Link to="/seller/domestic-hvi?product=cotton" className="pb-dropdown-link">☁️ Domestic Cotton (HVI)</Link>
                <Link to="/seller/domestic-description" className="pb-dropdown-link">📋 Cotton Description</Link>
                <Link to="/seller/import-recap" className="pb-dropdown-link">🚢 Import Cotton (Recap)</Link>
                <Link to="/yarn" className="pb-dropdown-link">🧵 Cotton Yarn</Link>
                <Link to="/seller/domestic-hvi?product=viscose" className="pb-dropdown-link">🧶 Viscose & Blends</Link>
                <Link to="/mmf" className="pb-dropdown-link">🏭 Man-Made Fibre (MMF)</Link>
              </div>
            </li>

            <li className="pb-nav-item">
              <span>Spot & Forward Rates</span>
              <span className="pb-nav-arrow">▼</span>
              <div className="pb-dropdown-panel">
                <Link to="/seller/domestic-hvi" className="pb-dropdown-link">📊 CAI Benchmark Daily Rates</Link>
                <Link to="/seller/domestic-hvi" className="pb-dropdown-link">📈 MCX Futures Reference</Link>
                <Link to="/seller/domestic-hvi" className="pb-dropdown-link">📅 Forward Delivery Contracts</Link>
              </div>
            </li>

            <li className="pb-nav-item">
              <span>Orders & Bids</span>
              <span className="pb-nav-arrow">▼</span>
              <div className="pb-dropdown-panel">
                <Link to="/buyer/inquiry-cotton" className="pb-dropdown-link">📢 Post Buyer Inquiry</Link>
                <Link to="/buyer/domestic-hvi" className="pb-dropdown-link">⚡ Live Bidding Marketplace</Link>
              </div>
            </li>

            <li className="pb-nav-item" onClick={() => setShowExpertModal(true)}>
              <span>Support & Help</span>
              <span className="pb-nav-arrow">▼</span>
            </li>
          </ul>

          <div className="pb-nav-actions">
            {user ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <button 
                  type="button" 
                  className="pb-btn-signin"
                  onClick={() => navigate('/role-selection')}
                  style={{ background: '#0284c7', color: '#ffffff' }}
                >
                  Dashboard ({user.name ? user.name.split(' ')[0] : 'Trade'})
                </button>
                <button
                  type="button"
                  onClick={logout}
                  style={{ background: 'transparent', border: '1px solid #cbd5e1', color: '#64748b', padding: '7px 12px', borderRadius: '9999px', fontSize: '0.8rem', cursor: 'pointer', fontWeight: '600' }}
                >
                  Sign Out
                </button>
              </div>
            ) : (
              <Link to="/login" className="pb-btn-signin" id="pb-signin-btn">
                Sign in
              </Link>
            )}
          </div>
        </div>
      </header>

      {/* ---------------- Hero Section ---------------- */}
      <section className="pb-hero-section">
        {/* Left Side: Headline & Value Props */}
        <div className="pb-hero-left">
          <div>
            <h2 className="pb-hero-title-sub">Let's find you</h2>
            <h1 className="pb-hero-title-main">the <span>Best Commodity Trade</span></h1>
          </div>

          <div className="pb-hero-value-props">
            <div className="pb-prop-badge">
              <div className="pb-prop-icon-circle purple">
                ⚖️
              </div>
              <div className="pb-prop-text">
                500+ Ginners offering lowest mill prices
              </div>
            </div>

            <div className="pb-prop-badge">
              <div className="pb-prop-icon-circle orange">
                ⚡
              </div>
              <div className="pb-prop-text">
                Quick, easy & hassle free
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Hero Promo Card Carousel */}
        <div className="pb-hero-right">
          <div className="pb-promo-card">
            <div className="pb-promo-content">
              <h3 className="pb-promo-headline">{promoBanners[activeBannerIdx].headline}</h3>
              <div className="pb-promo-ribbon">{promoBanners[activeBannerIdx].ribbon}</div>
              <div>
                <button 
                  type="button" 
                  className="pb-promo-btn"
                  onClick={() => {
                    if (user) navigate('/role-selection');
                    else navigate('/login');
                  }}
                >
                  {promoBanners[activeBannerIdx].buttonText}
                </button>
              </div>
              <p className="pb-promo-legal">*Zero brokerage on introductory trades. Verified NABL lab parameters.</p>
            </div>

            <div className="pb-promo-visual">
              <div className="pb-promo-badge-circle">
                <span className="rate-num">{promoBanners[activeBannerIdx].rate}</span>
                <span className="rate-sub">{promoBanners[activeBannerIdx].rateSub}</span>
              </div>
            </div>
          </div>

          {/* Carousel dots */}
          <div className="pb-carousel-dots">
            {promoBanners.map((_, idx) => (
              <div 
                key={idx} 
                className={`pb-dot ${activeBannerIdx === idx ? 'active' : ''}`}
                onClick={() => setActiveBannerIdx(idx)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- 14-Cards Product Grid ---------------- */}
      <section className="pb-grid-section">
        <div className="pb-cards-grid">
          {productCards.map((product) => (
            <div 
              key={product.id} 
              className="pb-card-item"
              onClick={() => handleCardClick(product)}
              id={`pb-product-${product.id}`}
            >
              {product.badge ? (
                <div className={`pb-card-ribbon ${product.badgeClass}`}>
                  {product.badge}
                </div>
              ) : (
                <div className="pb-ribbon-empty"></div>
              )}
              
              <div className="pb-card-icon-wrap">
                {product.icon}
              </div>

              <h4 className="pb-card-title">{product.displayTitle}</h4>
            </div>
          ))}
        </div>

        {/* View all products button */}
        <div className="pb-view-all-wrapper">
          <button 
            type="button" 
            className="pb-btn-view-all"
            onClick={() => setShowAllProducts(!showAllProducts)}
            id="pb-view-all-toggle"
          >
            {showAllProducts ? 'Hide additional functions ▲' : 'View all products & features ▼'}
          </button>
        </div>
      </section>

      {/* ---------------- Expanded Features (Toggled or Detailed) ---------------- */}
      {showAllProducts && (
        <section className="pb-features-expanded">
          <div className="pb-features-container">
            <div className="pb-features-header">
              <h2>Complete Digital Commodity Trading Ecosystem</h2>
              <p>Everything you need to buy, sell, verify, and settle agricultural and textile commodities seamlessly.</p>
            </div>

            <div className="pb-features-grid">
              <div className="pb-feature-box">
                <span style={{ fontSize: '2rem' }}>📊</span>
                <h4>CAI & MCX Daily Benchmarks</h4>
                <p>Track live daily spot rates from Rajkot, Khandwa, Warangal, and Akola with real-time candy price adjustments.</p>
              </div>

              <div className="pb-feature-box">
                <span style={{ fontSize: '2rem' }}>🔬</span>
                <h4>100% NABL Lab Reports</h4>
                <p>Inspect precise staple length, micronaire, strength, Rd, and +b before entering any contract.</p>
              </div>

              <div className="pb-feature-box">
                <span style={{ fontSize: '2rem' }}>🛡️</span>
                <h4>Escrow & Payment Assurance</h4>
                <p>Protected digital settlement and automated e-contracts with binding legal enforceability.</p>
              </div>

              <div className="pb-feature-box">
                <span style={{ fontSize: '2rem' }}>🚚</span>
                <h4>Pan-India Transit & Storage</h4>
                <p>Verified logistics network and WDRA-accredited godowns across major cotton-growing states.</p>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ---------------- Trust Strip ---------------- */}
      <footer className="pb-trust-strip">
        <div className="pb-trust-container">
          <div className="pb-trust-item">
            <h3>10,000+</h3>
            <p>Candies Traded Monthly</p>
          </div>
          <div className="pb-trust-item">
            <h3>500+</h3>
            <p>Verified Ginners & Mills</p>
          </div>
          <div className="pb-trust-item">
            <h3>₹0</h3>
            <p>Hidden Platform Charges</p>
          </div>
          <div className="pb-trust-item">
            <h3>100%</h3>
            <p>Transparency & Verified Quality</p>
          </div>
        </div>
      </footer>

      {/* ---------------- Interactive Role Selection Modal ---------------- */}
      {selectedProductForTrade && (
        <div className="pb-modal-backdrop" onClick={() => setSelectedProductForTrade(null)}>
          <div className="pb-modal-box" onClick={e => e.stopPropagation()}>
            <button className="pb-modal-close" onClick={() => setSelectedProductForTrade(null)}>✕</button>
            <div style={{ textAlign: 'center', marginBottom: '14px' }}>
              <span style={{ fontSize: '2.5rem' }}>{selectedProductForTrade.icon}</span>
              <h3 className="pb-modal-title" style={{ marginTop: '8px' }}>Trade {selectedProductForTrade.displayTitle}</h3>
              <p className="pb-modal-subtitle">{selectedProductForTrade.subtext}</p>
            </div>

            <div className="pb-role-choices">
              <div 
                className="pb-role-option-card"
                onClick={() => handleSelectRoleAndProceed('seller')}
                id="modal-select-seller"
              >
                <div className="pb-role-icon">🏷️</div>
                <div className="pb-role-name">I want to Sell</div>
                <div className="pb-role-desc">Publish lots, configure price & premium, receive buyer bids</div>
              </div>

              <div 
                className="pb-role-option-card"
                onClick={() => handleSelectRoleAndProceed('buyer')}
                id="modal-select-buyer"
              >
                <div className="pb-role-icon">🛒</div>
                <div className="pb-role-name">I want to Buy</div>
                <div className="pb-role-desc">Browse live ginning lots, place competitive bids & book orders</div>
              </div>
            </div>

            <div style={{ textAlign: 'center' }}>
              <button 
                type="button" 
                onClick={() => setSelectedProductForTrade(null)}
                style={{ background: 'transparent', border: 'none', color: '#64748b', fontSize: '0.85rem', cursor: 'pointer', textDecoration: 'underline' }}
              >
                Cancel and return
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ---------------- Talk to Expert Modal ---------------- */}
      {showExpertModal && (
        <div className="pb-modal-backdrop" onClick={() => setShowExpertModal(false)}>
          <div className="pb-modal-box" onClick={e => e.stopPropagation()}>
            <button className="pb-modal-close" onClick={() => setShowExpertModal(false)}>✕</button>
            <h3 className="pb-modal-title">Speak with Commodity Expert</h3>
            <p className="pb-modal-subtitle">Our trade specialists help you secure top rates and verified gin lots.</p>

            {expertSuccess ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: '#16a34a' }}>
                <span style={{ fontSize: '3rem' }}>✅</span>
                <h4 style={{ margin: '10px 0 4px 0', fontSize: '1.2rem' }}>Request Received!</h4>
                <p style={{ fontSize: '0.88rem', color: '#475569' }}>Our commodity specialist will call you within 15 minutes.</p>
              </div>
            ) : (
              <form onSubmit={handleExpertSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 700, color: '#334155', marginBottom: '4px' }}>Your Name</label>
                  <input 
                    type="text" 
                    required 
                    placeholder="e.g. Ramesh Patel" 
                    value={expertForm.name} 
                    onChange={e => setExpertForm({ ...expertForm, name: e.target.value })}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '0.9rem', boxSizing: 'border-box' }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 700, color: '#334155', marginBottom: '4px' }}>Mobile Number</label>
                  <input 
                    type="tel" 
                    required 
                    pattern="[0-9]{10}"
                    placeholder="10-digit mobile number" 
                    value={expertForm.mobile} 
                    onChange={e => setExpertForm({ ...expertForm, mobile: e.target.value })}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '0.9rem', boxSizing: 'border-box' }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 700, color: '#334155', marginBottom: '4px' }}>Commodity of Interest</label>
                  <select 
                    value={expertForm.commodity} 
                    onChange={e => setExpertForm({ ...expertForm, commodity: e.target.value })}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '0.9rem', boxSizing: 'border-box', background: '#ffffff' }}
                  >
                    <option value="Cotton HVI">Domestic Cotton (HVI)</option>
                    <option value="Cotton Yarn">Cotton Yarn (Carded/Combed)</option>
                    <option value="Viscose">Viscose & Blends</option>
                    <option value="MMF">Man-Made Fibre (Polyester)</option>
                    <option value="Organic Cotton">Organic & BCI Cotton</option>
                    <option value="Mill Leasing">Ginning / Spinning Mill Leasing</option>
                  </select>
                </div>

                <div style={{ background: '#f8fafc', padding: '10px', borderRadius: '8px', fontSize: '0.78rem', color: '#64748b' }}>
                  📞 Direct Hotline: <strong>+91 98765 43210</strong> (9:30 AM – 7:30 PM)
                </div>

                <button 
                  type="submit" 
                  style={{ background: '#0284c7', color: '#ffffff', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '0.95rem', fontWeight: 700, cursor: 'pointer', marginTop: '6px' }}
                >
                  Request Instant Callback
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;
